var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title mt-5" }, [
      _c("h3", { staticClass: "d-flex justify-content-center header" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("headers.hearing_test")) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-center ml-2 ml-md-0 mr-2 mr-md-0 mb-3"
      },
      [
        _c("span", { staticClass: "header header-2" }, [
          _vm._v(_vm._s(_vm.$t("headers.checkup")))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row m-0" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c(
          "span",
          {
            staticClass: "header header-4 header-start header-secondary",
            staticStyle: { color: "rgb(65,65,65)", "font-weight": "600" }
          },
          [_vm._v(_vm._s(_vm.$t("landing.before_start_label")))]
        ),
        _vm._v(" "),
        _c(
          "ol",
          { staticClass: "mt-3" },
          _vm._l(_vm.recommendations, function(recommendation) {
            return _c(
              "li",
              { key: recommendation.id, staticClass: "instructions" },
              [
                _c(
                  "div",
                  { staticClass: "recommendation-text label.custom-label" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(recommendation.text) +
                        "\n          "
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-md-3 d-flex align-items-end justify-content-center justify-content-md-start"
        },
        [
          _c(
            "button",
            {
              staticClass: "button primary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("continue")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("actions.start")))]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-md-3 d-none d-md-flex justify-content-center align-items-center"
      },
      [
        _c("img", {
          staticClass: "questionnaire-icon",
          attrs: { src: "public/questionnaire.svg", alt: "" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }